<template>
    <div class="we-toggle-text small ">
        <div
            :class="{
                active: this.fastFilterDateInterval === 'last_3_months',
            }"
            @click="manageFastFilterSelected('last_3_months')"
        >
            Ultimos 3 Meses
        </div>
        <div
            :class="{
                active: this.fastFilterDateInterval === 'last_12_months',
            }"
            @click="manageFastFilterSelected('last_12_months')"
        >
            Ultimos 12 Meses
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fastFilterDateInterval: "last_3_months",
        };
    },
    methods: {
        manageFastFilterSelected(optionSelected) {
            this.fastFilterDateInterval = optionSelected;
            this.$emit("organizationRankingFilterChange", optionSelected);
        },
    },
};
</script>
<style lang="scss" scoped>
.small {
    & > div {
        padding: 3px 8px;
        min-width: 30px;
        height: unset;
        font-size: 14px;
    }
}
</style>